<template>
  <div class="mb-3">
    <p class="form-label text-muted" v-if="label">{{ label }}</p>
    <div
      class="form-check"
      v-for="(item, index) in options"
      :key="'option_' + index"
    >
      <label
        class="form-check-label text-primary d-flex justify-content-between py-3"
        :for="'option_' + index"
      >
        {{ item.name || item.title }}
        <input
          class="form-check-input"
          type="checkbox"
          :value="item.id"
          v-model="model.$model"
          :id="'option_' + index"
          @change="onChange($event)"
        />
      </label>
      <hr class="m-0 p-0" v-if="index + 1 !== options.length" />
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    model?: any;
    label?: string;
    options?: any[];
  }>(),
  {
    model: () => ({}),
    label: "",
    options: () => [],
  },
);

const emit = defineEmits<{
  onChange: [value: string];
}>();

const onChange = (event: Event) => {
  emit("onChange", (event.target as HTMLInputElement).value);
};
</script>

<style scoped>
.form-check {
  padding-left: unset;
}
.form-check-input {
  margin-left: unset;
  float: right;
}
.form-check-input:checked {
  background-color: #fba486;
}
hr {
  border-color: #f2f2f2;
}
.form-check-input:focus:not(:checked) {
  background-color: #e5e5e5;
}
</style>
